<p-calendar styleClass="cap-calendar builder-timepicker" [timeOnly]="true" [formControl]="innerFormControl">
</p-calendar>
